<template>
  <div class="container-content consult row">
    <div class="left-nav col-md-3">
      <ul class="nav nav-pills nav-stacked">
        <li class="active">
          <a href="#">热点咨询 <i class="glyphicon glyphicon-chevron-down"></i></a>
          <ul class="sub-tab">
            <li :class="{active: curr==='计量'}" @click="switchPage('计量')"><a href="#">计量</a></li>
            <li :class="{active: curr==='标准'}" @click="switchPage('标准')"><a href="#">标准</a></li>
            <li :class="{active: curr==='认证认可'}" @click="switchPage('认证认可')"><a href="#">认证认可</a></li>
            <li :class="{active: curr==='检验检测'}" @click="switchPage('检验检测')"><a href="#">检验检测</a></li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="right col-md-9" v-if="curr=='计量'">
      <div class="right-word">
        <div class="right-title">什么是计量</div>
        <div class="right-content">计量是实现单位统一、量值准确可靠的活动。计量是技术和管理的结合体，凡是以实现计量单位统一和测量准确可靠为目的的科学、法
          制、管理等活动都属于计量的范畴。</div>
      </div>
      <div class="right-word">
        <div class="right-title">计量认证的作用</div>
        <div class="right-content">取得计量认证合格证书的检测机构，允许在检验报告上使用CMA标记；有CMA标记的检验报告可用于产品质量评价、成果及司法鉴
          定，具有法律效力。目前，计量认证已成为诸多行业，尤其是关系到百姓切身利益的行业评价检测机构检测能力的一种有效手段；同时
          也是检测机构进入市场的准入证。</div>
      </div>
      <div class="right-word">
        <div class="right-title">计量标准的不确定度</div>
        <div class="right-content"> 计量标准的不确定度是指在检定或校准结果的测量不确定度中，由计量标准所引入的不确定度分量。它既包括由计量标准器所引入
          的不确定度分量，也包括由配套设备所引入的不确定度分量。由于计量标准在测量结果中所引入的不确定分量与计量标准的使用方式
          有关，因此它不是计量标准的固有参数。</div>
      </div>
      <div class="right-word">
      <div class="right-title">计量标准的准确度等级</div>
      <div class="right-content"> 计量标准的准确度是指符合一定的计量要求，并使误差保持在规定极限以内的计量标准的等别或级别。准确度是一个定
        性的概念，通常都用准确度等级来表示。</div>
    </div>
    </div>
    <div class="right col-md-9" v-if="curr=='标准'">
      <div class="right-word">
        <div class="right-title">《标准化法》的性质是什么？</div>
        <div class="right-content">《中华人民共和国标准化法》是中华人民共和国的一项重要法律，《标准化法》规定了我国标准化工作的方针、政策、任务和标准化体制等。它是国家推行标准化，实施标准化管理和监督的重要依据。
        </div>
      </div>
      <div class="right-word">
        <div class="right-title">我国标准分为几级？</div>
        <div class="right-content">《中华人民共和国标准化法》将我国标准分为国家标准、行业标准、地方标准、企业标准四级</div>
      </div>
      <div class="right-word">
        <div class="right-title">我国各级标准分别由谁来制定？</div>
        <div class="right-content">我国的国家标准由国务院标准化行政主管部门制定；行业标准由国务院有关行政主管部门制定；地方标准由省、自治区和直辖市标准化行政主管部门制定；企业标准由企业自己制定。
        </div>
      </div>
      <div class="right-word">
        <div class="right-title">标准"备案"的作用主要有以下3点：</div>
        <div class="right-content"> ①可以了解标准的制定情况，特别是便于检查企业生产的产品是否制定了标准。如果企业生产的产品，既没有国家标准，又没有行业标准，也没有制定企业标准，就可以监督、帮助企业尽快制定企业标准。
      </div>
        <div class="right-content"> ②便于发现行业标准、地方标准或企业标准是否遵守有关强制性标准的情况。如果发现有违背的情况，可以及时予纠正或停止执行相应的标准。
        </div>
        <div class="right-content"> ③对于企业的产品标准来说，当供需双方由于产品贸易发生争议时，标准化行政主管部门可以依据合同规定的企业产品标准进行仲裁和检验。这个企业标准，应该是已备案的标准，而不是企业随意选用的标准。
        </div>
      </div>
      <div class="right-word">
        <div class="right-title">我国的强制性标准和推荐性标准是如何划分的，哪些标准属于强制性标准？</div>
        <div class="right-content">具有法律属性，在一定范围内通过法律、行政法规等手段强制执行的标准是强制性标准；其他标准是推荐性标准。</div>
      <div class="right-content"> ①药品、食品卫生、兽药、农药和劳动卫生标准；</div>
      <div class="right-content">②产品生产、贮运和使用中的安全及劳动安全标准；</div>
      <div class="right-content">③工程建设的质量、安全、卫生等标准；</div>
      <div class="right-content">根据《国家标准管理办法》和《行业标准管理办法》，下列标准属于强制性标准</div>
      <div class="right-content">④环境保护和环境质量方面的标准；</div>
    </div>
    </div>
    <div class="right col-md-9" v-if="curr=='认证认可'">
      <div class="right-word">
        <div class="right-title">什么是认证？</div>
        <div class="right-content"> 认证是指由认证机构证明产品、服务、管理体系符合相关技术规范、相关技术规范的强制性要求或者标准的合格评定活动。</div>
      </div>
      <div class="right-word">
        <div class="right-title">什么是认可？</div>
        <div class="right-content">认证通常分为产品、服务和管理体系认证。大家较为熟悉的CCC认证就是强制性产品认证。而体系认证包括：以ISO9001标准为依据开展的质量管理体系认证；以ISO14001标准为依据开展的环境管理体系认证；以GB/T28001标准为依据开展的职业健康安全管理体系认证；食品安全管理体系认证（HACCP）认证等。还有以体育场所服务标志为依据开展的体育服务认证等。
        </div>
      </div>
      <div class="right-word">
        <div class="right-title">什么是强制性产品认证？</div>
        <div class="right-content"> 强制性产品认证，又称CCC认证，是中国政府为保护广大消费者的人身健康和安全，保护环境、保护国家安全，依照法律法规实施的一种产品评价制度，它要求产品必须符合国家标准和相关技术规范。强制性产品认证，通过制定强制性产品认证的产品目录和强制性产品认证实施规则，对列入《目录》中的产品实施强制性的检测和工厂检查。凡列入强制性产品认证目录内的产品，没有获得指定认证机构颁发的认证证书，没有按规定加施认证标志，一律不得出厂、销售、进口或者在其他经营活动中使用。
        </div>
      </div>
      <div class="right-word">
        <div class="right-title">管理体系认证的分类</div>
        <div class="right-content">管理体系认证又分为质量管理体系、环境管理体系，职业健康安全管理体系，测量管理体系，以及良好农业规范（GAP）、良好性规范（GMP）危害分析与关键控制点体系（HACCP）等。
        </div>
      </div>
    </div>
    <div class="right col-md-9" v-if="curr=='检验检测'">
      <div class="right-word">
        <div class="right-title">常规试验(又称出厂试验)</div>
        <div class="right-content">检查产品材料和加工的质量缺陷，并检测产品固有性能，常包括功能试验和安全试验项目。</div>
      </div>
      <div class="right-word">
        <div class="right-title">抽样试验</div>
        <div class="right-content">在有关产品标准中有此项要求时进行，试验同样是用来验证产品规定的性能和特性。这些规定可由制造厂提出或由制造厂与用户协商。
          </div>
      </div>
      <div class="right-word">
        <div class="right-title">特殊试验</div>
        <div class="right-content"> 可根据有关产品标准及制造厂与用户协议进行，以满足市场对产品的多样化需求。

          对于假冒伪劣商品的鉴别，一般消费者和基层经销单位限于条件，通常只能采用直观的感官 检验方法，因而这部分内容

          也是本书讲述的重点，同时也介绍一些简单易行的物理和化学检 验方法，以及一些容易操作的简单仪器和仪表或专用

          设备，来弥补感官检验方法的不足。</div>
      </div>
    </div>
<!--    <div class="right-content col-md-9">-->
<!--      <div class="content-summary">-->
<!--        <span class="left-title">{{curr}}</span>-->
<!--        <span class="right-input form-inline">-->
<!--          <input class="form-control" type="text" placeholder="您要咨询什么业务，试着检索一下">-->
<!--          <button type="button" class="btn btn-default">-->
<!--            <span class="glyphicon glyphicon-search" aria-hidden="true"></span>-->
<!--          </button>-->
<!--        </span>-->
<!--      </div>-->
<!--      <div class="content-list">-->
<!--        <div class="content-tab active">-->
<!--          <ul>-->
<!--            <li>-->
<!--              <router-link to="/consult/detail"><span class="title">工作网常见问题及解答(2017版)(2017版)</span><span class="time">2017-11-01</span></router-link>-->
<!--            </li>-->
<!--            <li>-->
<!--              <router-link to="/consult/detail"><span class="title">数据待确认</span><span class="time">2019-10-24</span></router-link>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>
export default {
  name: 'consult',
  data () {
    return {
      curr: '计量'
    };
  },
  mounted () {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  },
  methods: {
    switchPage (page) {
      this.curr = page;
    }
  }
};
</script>
<style lang="less" scoped>
.consult {
  margin-top: 24px;
  .left-nav {
    .nav {
      li {
        a i {
          float: right;
        }
        &.active > a {
          background-color: @color-base;
        }
        .sub-tab {
          padding-top: 6px;
          border-width: 0 1px 1px 1px;
          border-color: rgba(0, 0, 0, 0.1);
          border-style: solid;
          border-radius: 4px;
          margin-top: -6px;
          li {
            cursor: pointer;
            height: 40px;
            line-height: 40px;
            padding-left: 20px;
            a {
              font-size: 16px;
              background-color: #ffffff;
              color: #666666;
              text-decoration: none;
            }
            &.active {
              a {
                font-size: 16px;
                font-weight: bold;
                color: @color-base;
              }
            }
            &:hover {
              /*background-color: #f4f4f4;*/
            }
          }
        }
      }
    }
  }
  .right-content {
    .content-summary {
      background-color: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      height: 50px;
      padding: 7px 20px;
      position: relative;
      z-index: 2;
      .left-title {
        color: @color-base;
        font-weight: bold;
        font-size: 16px;
        line-height: 36px;
        float: left;
      }
      .right-input {
        float: right;
        .form-control {
          width: 240px;
          margin-right: -10px;
        }
      }
    }
    .content-list {
      position: relative;
      z-index: 1;
      background-color: #ffffff;
      border-width: 0 1px 1px 1px;
      border-color: rgba(0, 0, 0, 0.1);
      border-style: solid;
      border-radius: 4px;
      margin-top: -6px;
      padding-top: 6px;
      height: 500px;
      .content-tab {
        display: none;
        &.active {
          display: block;
        }
        li {
          cursor: pointer;
          height: 40px;
          line-height: 40px;
          padding: 0 20px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          a {
            text-decoration: none;
            color: #666666;
          }
          .title {
          }
          .time {
            float: right;
          }
          &:hover {
            background-color: #f4f4f4;
          }
        }
      }
    }
  }
  .right{
    padding-bottom: 30px;
    background-color: #fff;
    .right-word{
      .right-title{
        margin: 40px 0 26px 40px;
        padding-left: 10px;
        line-height: 18px;
        font-weight: 600;
        font-size: 14px;
        border-left: 4px solid @color-base;
      }
      .right-content{
        padding:0 40px;
        font-size: 13px;
        text-indent:36px;
        line-height: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/consult/index.vue